import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';


Snappy.Component.Tabs = class Tabs extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-tabs';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.setDefaultState();

    }

    setVars() {
        this.$links =  this.$element.find('.js-tab-link');
        this.$tabs = this.$element.find('.js-tab');
    }

    setEventListeners() {
        this.$links.on('click', this.clickProcess.bind(this));
    }

    setDefaultState() {
        let $activeLink = (this.$links.filter('.is-active').length) ? this.$links.filter('.is-active') : this.$links.eq(0);
        let target = $activeLink.attr('href').substr(1);

        $activeLink.addClass('is-active');
        $activeLink.attr('aria-selected', 'true');

        this.selectTab(target);

    }

    clickProcess(e) {
        let $activeLink = $(e.target);
        let target = $activeLink.attr('href').substr(1);


        this.$links.removeClass('is-active');
        this.$links.attr('aria-selected', 'false');

        $activeLink.addClass('is-active');
        $activeLink.attr('aria-selected', 'true');

        this.selectTab(target);
        e.preventDefault();
    }

    selectTab(name) {
        let $activeTab = this.$tabs.filter(`[data-target='${name}']`);
        this.$tabs.removeClass('is-active');
        this.$tabs.attr('aria-hidden', 'true');

        $activeTab.addClass('is-active');
        $activeTab.attr('aria-hidden', 'false');
    }
};





// WEBPACK FOOTER //
// ./components/tabs/scripts/tabs.js